export interface DismissedModalResult {
	dismissed: true;
}

export function isDismissedModalResult (result: unknown): result is DismissedModalResult {
	return result != null
		&& typeof result === 'object'
		&& (result as DismissedModalResult).dismissed === true;
}
